import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useLocale } from "../i18n";
import { Menu, X } from "lucide-react";
import { FEATURE_ENABLED as WJ_ENABLED } from "../lib/wowJourneyApi";

export default function Header() {
  const { locale, setLocale, t } = useLocale();
  const [mobileOpen, setMobileOpen] = useState(false);

  const linkCls = ({ isActive }) =>
    `text-[13px] tracking-wide uppercase font-medium transition-colors duration-300 link-underline ${
      isActive ? "text-[var(--wr-red)]" : "text-[var(--wr-ink)] hover:text-[var(--wr-red)]"
    }`;

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-[var(--wr-border)] backdrop-blur-xl bg-[rgba(249,248,246,0.82)]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-baseline gap-2 group">
          <span className="font-editorial text-[26px] leading-none font-semibold tracking-tight text-[var(--wr-ink)]">
            wow<span className="text-[var(--wr-red)]">romania</span>
          </span>
          <span className="font-mono-wr text-[10px] uppercase tracking-widest text-[var(--wr-ink-2)] hidden sm:inline">
            .com
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-10" aria-label={locale === "ro" ? "Navigare principală" : "Primary"}>
          <NavLink to="/regions" className={linkCls} data-testid="nav-regions">{t("nav.regions")}</NavLink>
          <NavLink to="/tools" className={linkCls} data-testid="nav-tools">{t("nav.tools")}</NavLink>
          {WJ_ENABLED && <NavLink to="/plan" className={linkCls} data-testid="nav-plan">{t("nav.plan")}</NavLink>}
          <NavLink to="/concierge" className={linkCls} data-testid="nav-concierge">{t("nav.concierge")}</NavLink>
          <NavLink to="/about" className={linkCls} data-testid="nav-about">{t("nav.about")}</NavLink>
        </nav>

        <div className="flex items-center gap-4">
          <div className="font-mono-wr text-[11px] flex items-center gap-1 border border-[var(--wr-border)] rounded-full px-1 py-1" data-testid="locale-toggle">
            <button
              onClick={() => setLocale("en")}
              data-testid="locale-en"
              className={`px-2.5 py-1 rounded-full transition-colors duration-300 ${locale === "en" ? "bg-[var(--wr-ink)] text-[var(--wr-bg)]" : "text-[var(--wr-ink-2)] hover:text-[var(--wr-ink)]"}`}
            >EN</button>
            <button
              onClick={() => setLocale("ro")}
              data-testid="locale-ro"
              className={`px-2.5 py-1 rounded-full transition-colors duration-300 ${locale === "ro" ? "bg-[var(--wr-ink)] text-[var(--wr-bg)]" : "text-[var(--wr-ink-2)] hover:text-[var(--wr-ink)]"}`}
            >RO</button>
          </div>
          <button
            className="lg:hidden p-1 text-[var(--wr-ink)]"
            onClick={() => setMobileOpen(v => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="menu"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {mobileOpen && (
        <div className="lg:hidden border-t border-[var(--wr-border)] bg-[var(--wr-bg)]" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            <NavLink to="/regions" onClick={() => setMobileOpen(false)} className={linkCls}>{t("nav.regions")}</NavLink>
            <NavLink to="/tools" onClick={() => setMobileOpen(false)} className={linkCls}>{t("nav.tools")}</NavLink>
            {WJ_ENABLED && <NavLink to="/plan" onClick={() => setMobileOpen(false)} className={linkCls}>{t("nav.plan")}</NavLink>}
            <NavLink to="/concierge" onClick={() => setMobileOpen(false)} className={linkCls}>{t("nav.concierge")}</NavLink>
            <NavLink to="/about" onClick={() => setMobileOpen(false)} className={linkCls}>{t("nav.about")}</NavLink>
            <NavLink to="/contact" onClick={() => setMobileOpen(false)} className={linkCls}>{t("nav.contact")}</NavLink>
          </div>
        </div>
      )}
    </header>
  );
}
